import { useRef, useState } from 'react';
import { createPortalDOMNode } from '../utils/bundle.esm2.js';
import useIsomorphicLayoutEffect from './bundle.esm.js';

const usePortal = (name = "") => {
  const portalRef = useRef(null);
  const [portalNode, setPortalNode] = useState(null);
  useIsomorphicLayoutEffect(() => {
    if (portalNode)
      return;
    const newPortalNode = createPortalDOMNode(name);
    if (!newPortalNode)
      return;
    portalRef.current = newPortalNode;
    setPortalNode(newPortalNode);
  }, [portalNode]);
  useIsomorphicLayoutEffect(() => {
    const node = portalRef.current;
    return () => {
      if (typeof window === "undefined" || !node)
        return;
      document.body.removeChild(node);
    };
  }, []);
  return portalNode;
};

export { usePortal as default };
//# sourceMappingURL=bundle.esm2.js.map
